import { Autocomplete, Box, TextField } from "@mui/material";
import { actionTypesCodes, ActionTypeTag } from "../utils/ActionTypeTag";

type Props = {
	value: string;
	onChange: (value: string) => void;
};

export const ActionTypeFilter = ({ value, onChange }: Props) => {
	const selectedType =
		actionTypesCodes.find((c) => c.Code === value) || actionTypesCodes[0];

	return (
		<Autocomplete
			clearOnEscape
			autoHighlight
			options={actionTypesCodes}
			getOptionLabel={(option) => option.Name}
			disableClearable
			renderOption={(props, option) => (
				<Box
					{...props}
					component="li"
					sx={{
						display: "flex",
						alignItems: "center",
					}}
					gap={1}
				>
					<ActionTypeTag code={option.Code} />
					<span>{option.Name}</span>
				</Box>
			)}
			renderInput={(params) => (
				<TextField
					{...params}
					value={selectedType?.Name}
					label={"Action"}
					variant="outlined"
					fullWidth
					onChange={undefined}
					size="small"
					InputProps={{
						...params.InputProps,
						startAdornment: value ? (
							<Box ml={1}>
								<ActionTypeTag code={selectedType?.Code ?? ""} />
							</Box>
						) : null,
					}}
					inputProps={{
						...params.inputProps,
						"data-test-id": "action-type-selector",
					}}
				/>
			)}
			value={selectedType}
			onChange={(event, newValue) => {
				onChange(newValue?.Code ?? "");
			}}
		/>
	);
};
